import React from "react";
import { ELightPath, Roi } from "../../../Model/CaptureProfile";
import { LightPathCapability } from "../../../Model/ImagerCapabilities";
import DefaultImagingSettingRadioButton from "./DefaultImagingSettingRadioButton";
import CommonDropDown from "../../Common/DropDown/CommonDropDown";

const AUTO_SELECT_OBJECTIVE = "autoSelectObjective";
const FIXED_OBJECTIVE = "fixedObjective";

type Props = {
  style?: React.CSSProperties;
  lightPath: ELightPath;
  lightpathCapability: LightPathCapability;
  roi?: Roi;
  onValueChanged: (roi: Roi) => void;
  radioButtonId?: number;
  titleStyle?: React.CSSProperties;
  disabled?: boolean;
  fixedObjectiveDropDownDirection?: "up" | "down";
};

export default function RoiOptions({
  style = {},
  lightPath,
  lightpathCapability,
  roi,
  onValueChanged,
  radioButtonId,
  titleStyle = {},
  disabled = false,
  fixedObjectiveDropDownDirection = "down",
}: Props) {
  if (roi == null) {
    throw new Error("Roi is null");
  }

  const objectiveZoom = lightpathCapability.optic.objectiveZoom;

  if (objectiveZoom == null) {
    throw new Error("ObjectiveZoom is null");
  }

  const options = objectiveZoom.objectives.map((objective) => {
    return <option value={objective.value.toFixed(2)}> {objective.name} </option>;
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        ...style,
      }}
    >
      <div style={{ margin: "24px 0px", fontWeight: "bold", ...titleStyle }}>ROI Locate Options</div>

      <div
        style={{
          display: "grid",
          gridTemplateAreas: `'autoSelect autoSelect ' 
                            'fixedObjective objectiveSelection'`,
          gridTemplateColumns: "185px auto",
          gridTemplateRows: "auto auto",
          gridRowGap: "5px",
          marginTop: "5px",
          paddingLeft: "13px",
          ...style,
        }}
      >
        <DefaultImagingSettingRadioButton
          name={AUTO_SELECT_OBJECTIVE + radioButtonId}
          label="Auto Select Objective"
          checked={roi.autoSelectObjective === true}
          onChange={() => {
            onValueChanged({ ...roi, autoSelectObjective: true });
          }}
          style={{
            gridArea: "autoSelect",
          }}
          disabled={disabled}
        />

        <DefaultImagingSettingRadioButton
          name={AUTO_SELECT_OBJECTIVE + radioButtonId}
          label="Fixed Objective"
          checked={roi.autoSelectObjective === false}
          onChange={() => {
            onValueChanged({ ...roi, autoSelectObjective: false });
          }}
          style={{
            gridArea: "fixedObjective",
          }}
          disabled={disabled}
        />

        {/* <select
          style={{
            width: "190px",
            height: "34px",
            border: "1px slid #414042",
            gridArea: "objectiveSelection",
          }}
          name={FIXED_OBJECTIVE + radioButtonId}
          disabled={roi[AUTO_SELECT_OBJECTIVE] === true || disabled}
          onChange={(e) => {
            onValueChanged({ ...roi, fixedObjective: Number.parseFloat(e.target.value) });
          }}
          value={roi[FIXED_OBJECTIVE].toFixed(2)}
        >
          {options}
        </select> */}
        <CommonDropDown
          id={FIXED_OBJECTIVE + radioButtonId}
          dropDirection={fixedObjectiveDropDownDirection}
          style={{
            width: "190px",
            height: "34px",
            borderColor: "#414042",
            gridArea: "objectiveSelection",
          }}
          value={roi[FIXED_OBJECTIVE].toFixed(1)}
          disabled={roi[AUTO_SELECT_OBJECTIVE] === true || disabled}
          onChange={(value) => {
            onValueChanged({ ...roi, fixedObjective: Number.parseFloat(value) });
          }}
          dropDownDisplayValues={objectiveZoom.objectives.map((objective) => {
            return {
              display: objective.name,
              value: objective.value.toFixed(1),
              disabled: false
            };
          })}
        />
      </div>
    </div>
  );
}
